exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3WJtoDbcpSBPv3qYYebCpt:before{color:\"[theme:redDark, default:#a80000]\"!important}._3zKfXFAsr-_3xMEbOkhiUl:before{color:#ff8c00!important}html[dir] ._3zKfXFAsr-_3xMEbOkhiUl:before{margin-bottom:2px}.Tp9PMLh2NPBJDNi1-ods8:before{color:\"[theme:themePrimary, default:#0078D7]\"!important}", ""]);

// exports
exports.locals = {
	"redDark": "_3WJtoDbcpSBPv3qYYebCpt",
	"snooze": "_3zKfXFAsr-_3xMEbOkhiUl",
	"accounts": "Tp9PMLh2NPBJDNi1-ods8"
};